export default __webpack_public_path__ + "static/media/android_1.1437e33e.jpg";